var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect10, _rect11, _rect12, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 516.01 516.01",
    width: 517,
    height: 517,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.76,
    y: 56.31,
    width: 10,
    height: 47.08,
    transform: "translate(-19.59 86.58) rotate(-30)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.31,
    y: 359.25,
    width: 47.08,
    height: 10,
    transform: "translate(-171.43 88.72) rotate(-30)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 133.3,
    y: 434.09,
    width: 47.08,
    height: 10,
    transform: "translate(-301.84 355.37) rotate(-60)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 250.07,
    y: 27.05,
    width: 10,
    height: 47.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.05,
    y: 255.93,
    width: 47.08,
    height: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.93,
    y: 441.87,
    width: 10,
    height: 47.08
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.92,
    y: 133.3,
    width: 10,
    height: 47.08,
    transform: "translate(-97.37 145.03) rotate(-60)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.44,75.57C391.71,26.84,326.92,0,258,0S124.3,26.84,75.57,75.57,0,189.09,0,258s26.84,133.71,75.57,182.44c48.73,48.73,113.52,75.57,182.44,75.57s133.71-26.84,182.44-75.57,75.57-113.52,75.57-182.44-26.84-133.71-75.57-182.44Zm-7.07,357.8c-46.84,46.84-109.12,72.64-175.37,72.64s-128.52-25.8-175.36-72.64C35.8,386.53,10,324.25,10,258S35.8,129.48,82.64,82.64C129.48,35.8,191.76,10,258,10s128.52,25.8,175.37,72.64,72.64,109.12,72.64,175.37-25.8,128.52-72.64,175.37Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 412.62,
    y: 146.76,
    width: 47.08,
    height: 10,
    transform: "translate(-17.45 238.41) rotate(-30)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 441.87,
    y: 250.07,
    width: 47.08,
    height: 10
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 434.09,
    y: 335.63,
    width: 10,
    height: 47.08,
    transform: "translate(-91.5 559.85) rotate(-60)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 359.25,
    y: 412.62,
    width: 10,
    height: 47.08,
    transform: "translate(-169.28 240.55) rotate(-30)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 335.63,
    y: 71.92,
    width: 47.08,
    height: 10,
    transform: "translate(112.97 349.51) rotate(-60)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "264.38 92.09 247.45 92.09 247.45 238.72 151.33 183.23 136.1 209.61 247.45 273.9 247.45 283.79 264.38 283.79 264.38 283.68 267.05 285.22 282.29 258.83 264.38 248.49 264.38 92.09"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3931baa66acaad0f19067d3b900c6e45.svg";
export { ForwardRef as ReactComponent };